import { createTheme, type Theme } from '@mui/material/styles';

/**
 * The public page is always light while both hosts can run dark, so it never inherits their
 * palette. Built with no options so a host that augments `PaletteOptions` cannot break it.
 */
export const landingPageTheme: Theme = createTheme();
